import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { MaintenanceService } from '../services/maintenance.service';

/**
 * Blocks the public client site while maintenance mode is active.
 * Partner areas stay accessible (banner only); admin/auth are not guarded.
 */
export const maintenanceBlockGuard: CanActivateFn = () => {
  const maintenance = inject(MaintenanceService);
  const router = inject(Router);

  return maintenance.ensureChecked().pipe(
    map((active) => (active ? router.createUrlTree(['/maintenance']) : true)),
  );
};
